// Soul Pit e Animus Mastery (Tibia 14), adaptados ao Noxara (decisão do Arthur, 14/10):
// os monstros das hunts dropam o Soul Core deles (raro, mais fácil nas criaturas fracas); usar o Soul Core abre uma luta
// em ondas contra versões fortalecidas da criatura numa arena só sua. Vencer a última onda (o campeão) dá a Animus Mastery:
// +10% de XP ao caçar aquela criatura e +0,1% de XP geral por mastery, sem limite (decisão do Arthur, 14/10). Números propostos por mim.

/** onda: quantidade e reforço (vida e dano) dos monstros; na última, o campeão vem com mais monstros (minions).
 *  Ondas maiores (decisão do Arthur, 15/10): 10, 20, 30 e o campeão com 40. Cada monstro dá a XP e o loot normais dele. */
export interface SoulWave { count: number; hp: number; dmg: number; champion?: boolean; minions?: { count: number; hp: number; dmg: number } }
export const SOULPIT_WAVES: SoulWave[] = [
  { count: 10, hp: 1.5, dmg: 1.2 },
  { count: 20, hp: 1.75, dmg: 1.3 },
  { count: 30, hp: 2, dmg: 1.4 },
  { count: 1, hp: 15, dmg: 1.6, champion: true, minions: { count: 40, hp: 2, dmg: 1.4 } },
];
export const ANIMUS_XP_PCT = 10;
export const ANIMUS_GENERAL_PCT = 0.1;
/** sem teto para o bônus geral (decisão do Arthur, 14/10) */
export const ANIMUS_GENERAL_MAX = Infinity;

/** chance de o Soul Core cair por abate: ~1 em 1.000 nas criaturas fracas, mais rara nas fortes */
export function soulCoreChance(exp: number): number {
  return 0.001 * Math.sqrt(500 / (500 + Math.max(0, exp)));
}
/** bônus geral de XP (%) pelo número de masteries */
export function animusGeneral(n: number): number { return Math.round(n * ANIMUS_GENERAL_PCT * 10) / 10; }
export const soulCoreName = (monster: string) => `${monster.toLowerCase()} soul core`;
export const monsterOfCore = (itemName: string) => itemName.toLowerCase().replace(/ soul core$/, '');
